import React, { Component } from 'react';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import IsolatedScroll from 'react-isolated-scroll';
import { Translate } from 'react-redux-i18n';
import { Row, Col } from 'react-bootstrap';
import { fetchProductSuggestions } from '../../actions/autoSuggest_actions';
import { fetchPurchaseOrderProductByID } from '../../actions/purchaseOrders_actions';
import { isOLG, isGGI, isSH, isAP, isGFD, isBRO } from '../../actions/root_url';

/* --------------- */
/*    Component    */
/* --------------- */
class GenericProductSuggest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      suggestions: [],
      Product_id: 0,
      noSuggestions: false,
      fetchBy: props.fetchBy || 'ProductNum',
    };
    this.lastRequestId = null;
  }

  componentWillReceiveProps(nextProps) {
    const isInputBlank = nextProps.value === '';
    const noSuggestions = !isInputBlank && nextProps.productSuggestions.length === 0;
    this.setState({ noSuggestions });
    if (nextProps.productSuggestions && nextProps.productSuggestions !== this.props.productSuggestions) {
      this.setState({ isLoading: false, suggestions: [...(nextProps.productSuggestions).slice(0, 200)] });
    }
    if (nextProps.fetchBy !== this.props.fetchBy) {
      this.setState({
        fetchBy: nextProps.fetchBy
      });
    }
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    if (!isGGI) {
      this.loadSuggestions(value);
    }
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onFocus(event) {
    event.target.select();
  }

  onKeyPress = (event) => {
    if (isGGI && event.charCode === 13) {
      this.loadSuggestions(event.target.value)
    }
  }

  onSuggestionSelected = (event, { suggestion }) => {
    let savedEvent = event.target
    // function to get product here
    event.stopPropagation();
    event.preventDefault();
    if (this.props.setProductNum) {
      this.props.setProductNum(suggestion.ProductNum);
    }
    this.props.fetchOrdersByProduct(suggestion[this.state.fetchBy], suggestion, savedEvent);
  }

  getSuggestionValue = (suggestion) => {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return `${suggestion.ProductNum} | ${suggestion.Name}`;
      case 'RefNum':
        return `${suggestion.RefNum} | ${suggestion.Name}`;
      case 'InStock':
        return suggestion.InStock;
      case 'Name':
        return suggestion.Name;
      case 'Description':
        return `${suggestion.Description} | ${suggestion.Name}`;
      case 'Barcode':
        return `${suggestion.Description} | ${suggestion.Name}`;
      default:
        return 'search type not found --111';
    }
  }

  loadSuggestions(value) {
    let warehouse = '';
    let company = '';
    if (isGGI && this.props.selectedCompany && this.props.selectedCompany.value) {
      company = this.props.selectedCompany.value;
    }
    if (this.props.selectedWarehouse && this.props.selectedWarehouse.value) {
      warehouse = this.props.selectedWarehouse.value;
    }
    this.props.fetchProductSuggestions(this.props.SearchType, value, warehouse, company, this.props.pkgTp);
  }

  renderErrorMessage() {
    const { noSuggestions } = this.state;
    if (noSuggestions && !this.props.productSuggestionsIsLoading) {
      return (
        <div className="no-suggestions">
          <Translate value="no_data_found" />
        </div>
      );
    }
    return <div />;
  }

  // not used
  renderSearchTypeValue(suggestion) {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return suggestion.ProductNum;
      default:
        return suggestion.RefNum;
    }
  }

  renderSuggestion = (suggestion) => {
    return (
      <Row className="suggestion" id="suggestion-render" className="sales-auto-suggest-suggestions">
        { !(isOLG || isSH || isAP) &&
          <Col xs={2}>
            {suggestion.ProductNum}
          </Col>
        }
        <Col xs={(isSH || isAP) ? 6 : 2}>
          {suggestion.RefNum}
        </Col>
        { !(isSH || isAP) &&
          <Col xs={2}>
            {suggestion.InStock}
          </Col>
        }
        {!isBRO &&
        <Col xs={(isSH || isAP) ? 6 : isGFD ? 3 : 5}>
          {suggestion.Name}
        </Col>
  }
        {isGFD && <Col xs={1}>
          {suggestion.PriceLv5}
        </Col>}
        { !(isSH || isAP) &&
          <Col xs={isGFD ? 2 : isBRO ? 4 : 1}>
            {suggestion.Description}
          </Col>
        }
      </Row>
    )
  }

  // not used
  renderSearchTypeHeader = () => {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return <Translate value="prod_num" />;

      default:
        return <Translate value={isOLG ? "item_no" : "ref_num"} />;
    }
  }

  renderSuggestionsContainer = ({ containerProps, children }) => {
    const { ref, ...restContainerProps } = containerProps;
    const callRef = scrollingDiv => {
      if (scrollingDiv !== null) {
        ref(scrollingDiv.component);
      }
    };

    return (
      <div {...restContainerProps} style={{ width: isGFD ? '200%' : '100%' }}>
        <div className="container" style={{ width: '100%' }} id="suggestion-container">
          <Row style={{ padding: '10px 5px', margin: '0px' }} className="sales-auto-suggest-suggestions" id="sales-auto-suggest-header">
            { !(isOLG || isSH || isAP) &&
              <Col xs={2}>
                <Translate value="prod_num" />
              </Col>
            }
            <Col xs={(isSH || isAP) ? 6 : 2}>
              <Translate value={isOLG ? "item_no" : "ref_num"} />
            </Col>
            { !(isSH || isAP) &&
              <Col xs={2}>
                <Translate value="inventory" />
              </Col>
            }
            {!isBRO &&
            <Col xs={(isSH || isAP) ? 6 : isGFD ? 3 : 5}>
              <Translate value="prod_name" />
            </Col>
  }
            {isGFD && <Col xs={1}>
              <Translate value="price" />
            </Col>}
            { !(isSH || isAP) &&
              <Col xs={isGFD ? 2 : isBRO ? 4 : 1}>
                <Translate value="desc" />
              </Col>
            }
          </Row>
        </div>
        <IsolatedScroll id="suggestions-customer-container" ref={callRef}>
          {children}
        </IsolatedScroll>
      </div>
    );
  }

  render() {
    const { suggestions } = this.state;
    const inputProps = {
      value: this.props.value,
      onChange: this.props.onChange,
      onKeyPress: this.onKeyPress,
      onFocus: this.onFocus,
      id: 'purchase-auto-suggest',
    };

    return (
      <div>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          focusInputOnSuggestionClick={false}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          renderSuggestionsContainer={this.renderSuggestionsContainer}
          onSuggestionSelected={this.onSuggestionSelected}
          highlightFirstSuggestion = {isGGI ? false : true}
          inputProps={inputProps}
        />
        {this.renderErrorMessage()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    productSuggestions: state.autoSuggest.productSuggestions,
    productSuggestionsIsLoading: state.autoSuggest.productSuggestionsIsLoading,
    productSuggestionsError: state.autoSuggest.productSuggestionsError,
    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,
  };
}

export default connect(mapStateToProps, { fetchPurchaseOrderProductByID, fetchProductSuggestions })(GenericProductSuggest);



// WEBPACK FOOTER //
// ./master/jsx/containers/Common/GenericProductSuggest.jsx